/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_One_TableInputs */



/**
* | output |
* | --- |
* | "Finals expects exactly one table" |
*
* @param {Err_Tournament_Finals_One_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_one_table = /** @type {((inputs?: Err_Tournament_Finals_One_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_One_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La finale attend exactement une table")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las finales requieren exactamente una mesa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A final requer exatamente uma mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le finali prevedono esattamente un tavolo")
	return /** @type {LocalizedString} */ ("Finals expects exactly one table")
});